import { render, staticRenderFns } from "./NewsDynamic.vue?vue&type=template&id=03e8e523&scoped=true&"
import script from "./NewsDynamic.vue?vue&type=script&lang=js&"
export * from "./NewsDynamic.vue?vue&type=script&lang=js&"
import style0 from "./NewsDynamic.vue?vue&type=style&index=0&id=03e8e523&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e8e523",
  null
  
)

export default component.exports